import { AREA_SELECT_PROVINCE, AREA_SELECT_CITY } from "../constants/areaConstants";
export const areaEditReducer = (state = {}, action) => {
    switch (action.type) {
        case AREA_SELECT_PROVINCE:
            return { ...state, selectedProvince: action.province };
            break;
        case AREA_SELECT_CITY:
            return { ...state, selectedCity: action.city };
            break;

        default:
            return state;
            break;
    }
}